/**
 * dimensions — the Audience-builder catalog (FEAT-ANALYTICS-002). Mirrors the
 * backend DIMENSION_REGISTRY: categories → dimensions → operators → value input.
 * Pure data + helpers (TDD). The GA "+" picker is rendered from this.
 */
export const OPERATOR_LABELS = {
  eq: 'is', ne: 'is not', in: 'is one of', not_in: 'is not one of',
  contains: 'contains', starts_with: 'starts with', ends_with: 'ends with',
  gt: '>', lt: '<', gte: '≥', lte: '≤', between: 'between',
  performed: 'performed', not_performed: 'did not perform', count: 'performed (count)',
};
const SEGMENT_OPS = ['in', 'not_in'];

const STRING_OPS = ['eq', 'ne', 'in', 'not_in', 'contains', 'starts_with', 'ends_with'];
const NUM_OPS = ['between', 'gte', 'lte', 'gt', 'lt', 'eq'];
const EVENT_OPS = ['performed', 'not_performed', 'count'];

// dim: { key, label, kind, operators, valueType }
const S = (key, label) => ({ key, label, kind: 'string', operators: STRING_OPS, valueType: 'text' });

export const CATEGORIES = [
  {
    key: 'segments', label: 'Segments',
    dims: [{ key: 'segment', label: 'Segment (Cohort)', kind: 'segment', operators: SEGMENT_OPS, valueType: 'segment' }],
  },
  {
    key: 'events', label: 'Events',
    dims: [{ key: 'event', label: 'Event', kind: 'event', operators: EVENT_OPS, valueType: 'event' }],
  },
  {
    key: 'demographics', label: 'Demographics',
    dims: [S('country', 'Country'), S('region', 'Region'), S('city', 'City'), S('language', 'Language')],
  },
  {
    key: 'page', label: 'Page / Screen',
    dims: [S('page', 'Page / screen')],
  },
  {
    key: 'platform', label: 'Platform / Device',
    dims: [S('channel', 'Channel'), S('browser', 'Browser'), S('os', 'Operating system'), S('device', 'Device'), S('platform', 'Platform'), S('app_version', 'App version')],
  },
  {
    key: 'traffic', label: 'Traffic source',
    dims: [S('channel_group', 'Channel group'), S('source', 'Source'), S('utm_source', 'UTM source'), S('utm_medium', 'UTM medium'), S('utm_campaign', 'UTM campaign'), S('referrer', 'Referrer')],
  },
  {
    key: 'campaigns', label: 'Campaigns',
    dims: [S('campaign_id', 'Campaign ID'), S('campaign_name', 'Campaign name'), S('utm_campaign', 'UTM campaign'), S('offer_id', 'Offer ID')],
  },
  {
    key: 'behavior', label: 'Behavior (xNotify)',
    dims: [
      { key: 'recency', label: 'Active in last N days', kind: 'time', operators: ['in'], valueType: 'days' },
      { key: 'revenue', label: 'Revenue (amount)', kind: 'numeric', operators: NUM_OPS, valueType: 'number' },
    ],
  },
];

const DIM_INDEX = {};
CATEGORIES.forEach((cat) => cat.dims.forEach((d) => { DIM_INDEX[d.key] = { ...d, category: cat.key }; }));

export function getDim(key) { return DIM_INDEX[key] || null; }
export function operatorsFor(key) { const d = DIM_INDEX[key]; return d ? d.operators : []; }
export function valueTypeFor(key) { const d = DIM_INDEX[key]; return d ? d.valueType : 'text'; }

/** A fresh default condition for a dimension. */
export function defaultCondition(dimKey) {
  const d = DIM_INDEX[dimKey];
  if (!d) return null;
  const base = { dim: dimKey, operator: d.operators[0] };
  if (d.kind === 'event') return { ...base, value: '', timeframe: 'last_30_days', count_op: 'gte', count: 1 };
  if (d.kind === 'time') return { ...base, value: 7 };
  if (d.kind === 'numeric') return { ...base, value: [0, 0] };
  if (d.kind === 'segment') return { ...base, value: [] }; // array of cohort ids
  return { ...base, value: '' };
}
